import { PagiPromiseResponseData } from '@/global'
import request from '../tools/request'
import { getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
const { GET, POST, uploadFilePOST } = request
interface FilingData {
  customer: string // 客户单位
  filingDeadline: string // 报备到期日
  id?: string
  orderTime?: string // 预计点单日
  platform: string // 下单平台
  price?: string // 报备金额
  productList?: any[] // 报备单商品明细
  remark?: string // 备注
  dockingSalesId: string // 对接销售oaid
  dockingSalesName: string // 对接销售
  customerMdmCode?: string // 客户单位主数据编码
  crmExists: boolean // CRM是否已存在该客户
}
// 新增或修改商品报备
export const SAVE_FILINGDATA = (params: FilingData) =>
  POST(
    `${HTTP}/filing/saveOrUpdateFiling`,
    { ...params, userId: getUserId() },
    'application/json',
  )

// 获取报备单详情
export const GET_FILINGDETAIL = (params: { filingId: string }) =>
  GET(`${HTTP}/filing/getFilingDetail`, params)

// 报备单导入
export const UPLOADFILE_ORDERFILING = (
  params: { supplierId: string; erpCode: string; userId: string },
  file: any,
) => uploadFilePOST(`${HTTP}/filing/importOrderFiling`, file, params)

/**
 * 报备单导出
 * @param params
 * @returns
 */
export const EXPORT_FILING = (params: {
  customer?: string // 客户名称
  filingArriveEndTime?: string // 到期日(截止)
  filingArriveStartTime?: string // 到期日(起始)
  filingEndTime?: string // 报备日期(截止)
  filingNo?: string //	报备单号
  filingOrderEndTime?: string // 预计点单日(截止)
  filingOrderStartTime?: string // 预计点单日(起始)
  filingStartTime?: string // 报备日期(起始)
  fillingState?: string // 报备单状态(1--报备中,2--已派单,3--已撤回)
  filingIds?: string // 报备单id串
  num?: number // 报备数量
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  platform?: string //	下单平台
  price?: number // 退货金额
  schemeId?: string //	方案id
  supplierId: string // 供应商id
  erpCode: string // erp编码
}) => GET(`${HTTP}/filing/exportFiling`, params)

export type PlatformItemRes = { platformCode: string; platformName: string }

export const GET_SUPPLIER_PLATFORM_LIST = () =>
  GET<PlatformItemRes[]>(
    `${HTTP}/supplier/getExclusivePlatformListBySupplierId`,
    {
      supplierId: getSupplierId(),
    },
  )

export type OrderNoFilingParam = {
  customer: string // 客户单位
  id?: string // 报备单id(修改传入)
  orderNo: string // 客户订单号
  platform: string // 下单平台
  price: number // 报备金额
  remark?: string // 备注
  supplierId?: string
  dockingSalesId: string // 对接销售oaid
  dockingSalesName: string // 对接销售
  crmExists?: string // 是否是CRM客户
}

export const SAVE_ORDERNO_FILING = (params: OrderNoFilingParam) =>
  POST(
    `${HTTP}/filing/saveOrUpdateOrderNoFiling`,
    {
      ...params,
      userId: getUserId(),
      supplierId: getSupplierId(),
    },
    'application/json',
  )

export type FilingNoDetailRes = {
  customer: string
  filingDeadline: string
  filingNo: string
  filingTime: string
  id: string
  orderNo: string
  platform: string
  platformName: string
  price: number
  remark: string
  state: string
  approvalOpinion: string // 钉钉审核驳回理由
  validity: string // 报备有效期
  dockingSalesJobNumber: string
}

export const GET_ORDERNO_FILILING_DETAIL = (params: { filingId: string }) =>
  GET<FilingNoDetailRes>(`${HTTP}/filing/getOrderNoFilingDetail`, params)

interface UserParams {
  mobile?: string // 联系方式
  name?: string // oa 用户名称
}
export interface oaUserItem {
  dingAvatar: string
  dingId: string
  dingUnionId: string
  email: string
  enabled: boolean
  id: string
  job: string
  mobile: string
  name: string
  oaId: string
  parentIds: string
  parentNames: string
  sex: string
  jobNumber: string
}
// 获取oa用户列表
export const GET_OA_USER_LIST = (params: UserParams) =>
  GET<oaUserItem[]>(`${HTTP}/oa-user/info`, params)

export interface PartnerDTO {
  crmExists: boolean
  customerName: string
  mdmCode: string
  show: boolean
}

export interface SearchCustomerParams {
  name?: string
  pageNo?: number
  pageSize?: number
}

export const GET_FILING_SEARCH_CUSTOMER_LIST = (
  params?: SearchCustomerParams,
): PagiPromiseResponseData<PartnerDTO[]> =>
  GET(`${HTTP}/filing/searchCrmCustomer`, params || {})
import { PagiPromiseResponseData } from '@/global'
import request from '../tools/request'
import { getSupplierId, getUserId } from '../tools/util'
import { HTTP } from './http'
const { GET, POST, uploadFilePOST } = request
interface FilingData {
  customer: string // 客户单位
  filingDeadline: string // 报备到期日
  id?: string
  orderTime?: string // 预计点单日
  platform: string // 下单平台
  price?: string // 报备金额
  productList?: any[] // 报备单商品明细
  remark?: string // 备注
  dockingSalesId: string // 对接销售oaid
  dockingSalesName: string // 对接销售
  customerMdmCode?: string // 客户单位主数据编码
  crmExists: boolean // CRM是否已存在该客户
}
// 新增或修改商品报备
export const SAVE_FILINGDATA = (params: FilingData) =>
  POST(
    `${HTTP}/filing/saveOrUpdateFiling`,
    { ...params, userId: getUserId() },
    'application/json',
  )

// 获取报备单详情
export const GET_FILINGDETAIL = (params: { filingId: string }) =>
  GET(`${HTTP}/filing/getFilingDetail`, params)

// 报备单导入
export const UPLOADFILE_ORDERFILING = (
  params: { supplierId: string; erpCode: string; userId: string },
  file: any,
) => uploadFilePOST(`${HTTP}/filing/importOrderFiling`, file, params)

/**
 * 报备单导出
 * @param params
 * @returns
 */
export const EXPORT_FILING = (params: {
  customer?: string // 客户名称
  filingArriveEndTime?: string // 到期日(截止)
  filingArriveStartTime?: string // 到期日(起始)
  filingEndTime?: string // 报备日期(截止)
  filingNo?: string //	报备单号
  filingOrderEndTime?: string // 预计点单日(截止)
  filingOrderStartTime?: string // 预计点单日(起始)
  filingStartTime?: string // 报备日期(起始)
  fillingState?: string // 报备单状态(1--报备中,2--已派单,3--已撤回)
  filingIds?: string // 报备单id串
  num?: number // 报备数量
  pageNo?: number //	当前页
  pageSize?: number //	每页展示数量
  platform?: string //	下单平台
  price?: number // 退货金额
  schemeId?: string //	方案id
  supplierId: string // 供应商id
  erpCode: string // erp编码
}) => GET(`${HTTP}/filing/exportFiling`, params)

export type PlatformItemRes = { platformCode: string; platformName: string }

export const GET_SUPPLIER_PLATFORM_LIST = () =>
  GET<PlatformItemRes[]>(
    `${HTTP}/supplier/getExclusivePlatformListBySupplierId`,
    {
      supplierId: getSupplierId(),
    },
  )

export type OrderNoFilingParam = {
  customer: string // 客户单位
  id?: string // 报备单id(修改传入)
  orderNo: string // 客户订单号
  platform: string // 下单平台
  price: number // 报备金额
  remark?: string // 备注
  supplierId?: string
  dockingSalesId: string // 对接销售oaid
  dockingSalesName: string // 对接销售
  crmExists?: string // 是否是CRM客户
}

export const SAVE_ORDERNO_FILING = (params: OrderNoFilingParam) =>
  POST(
    `${HTTP}/filing/saveOrUpdateOrderNoFiling`,
    {
      ...params,
      userId: getUserId(),
      supplierId: getSupplierId(),
    },
    'application/json',
  )

export type FilingNoDetailRes = {
  customer: string
  filingDeadline: string
  filingNo: string
  filingTime: string
  id: string
  orderNo: string
  platform: string
  platformName: string
  price: number
  remark: string
  state: string
  approvalOpinion: string // 钉钉审核驳回理由
  validity: string // 报备有效期
  dockingSalesJobNumber: string
}

export const GET_ORDERNO_FILILING_DETAIL = (params: { filingId: string }) =>
  GET<FilingNoDetailRes>(`${HTTP}/filing/getOrderNoFilingDetail`, params)

interface UserParams {
  mobile?: string // 联系方式
  name?: string // oa 用户名称
}
export interface oaUserItem {
  dingAvatar: string
  dingId: string
  dingUnionId: string
  email: string
  enabled: boolean
  id: string
  job: string
  mobile: string
  name: string
  oaId: string
  parentIds: string
  parentNames: string
  sex: string
  jobNumber: string
}
// 获取oa用户列表
export const GET_OA_USER_LIST = (params: UserParams) =>
  GET<oaUserItem[]>(`${HTTP}/oa-user/info`, params)

export interface PartnerDTO {
  crmExists: boolean
  customerName: string
  mdmCode: string
  show: boolean
}

export interface SearchCustomerParams {
  name?: string
  pageNo?: number
  pageSize?: number
}

export const GET_FILING_SEARCH_CUSTOMER_LIST = (
  params?: SearchCustomerParams,
): PagiPromiseResponseData<PartnerDTO[]> =>
  GET(`${HTTP}/filing/searchCrmCustomer`, params || {})
